import React, { useState, useContext, useEffect, useCallback, useMemo, useRef } from "react";
import "../../../../ui-styles/list/ListAutoUnderLine.css";
import "../../../../ui-styles/buttons/IconButton.css";
import "../BookAppointments.css";
import Button from "../../../../lib/ui/buttons/Button";
import { LangCtx,PayLoadCtx } from "../../../../lib/context";
// import "../../../ui-styles/list/FormList.css";
import { OffLineAPI } from "../../../../offline-auth/api";
import NoData from "../../../../lib/ui/nodata/NoData";
import { toast } from "react-toastify";
import InputField from "../../../../lib/ui/inputs/Input";
import Loader from "../../../../lib/ui/loader/Loader";
import { deleteS3, scan } from "../../../../actions/appointment";

const FileUploads = (props) => {
    const { l } = useContext(LangCtx);
    const [showInput, setShowInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [uploaddoc, setUploaddoc] = useState([]);
    const [changeFileName, setChangeFileName] = useState("");
    // const [holdUploadBody, setHoldUploadBody] = useState({});
    const { payload } = useContext(PayLoadCtx);
    const fileNameRef = useRef();
    const fileRef = useRef();
    const acceptedTypes = ["jpeg", "jpg", "png", "doc", "docx", "pdf", "xls", "xlsx", "ppt", "pptx", "mp4"];

    useEffect(() => {
        props.formData && props.formData.uploads && props.formData.uploads.length > 0
            ? setUploaddoc([...props.formData.uploads])
            : setUploaddoc([]);
    }, [props.formData]);

    /**
     * @param {string} fileName - name of the file
     * @param {Object} file - file to upload
     */
    const uploadOnlineOrOffline = (fileName, file) => {

        return new Promise(async (resolve, reject) => {
            let body = {
                uploadtype: file.type,
                size: file.size,
                date: file.lastModified,
                uploadname: changeFileName,
                senderName: `${payload.firstName}`
            };
            if (process.env.REACT_APP_isOffline === "true") {
                //upload to server folder
                const formData = new FormData();
                formData.append("fileData", file);
                try {
                    const offlineUploadRes = await OffLineAPI.upload("api", "/appointmentupload", formData);
                    body = {
                        ...body,
                        url: `${process.env.REACT_APP_api_server}/api/uploads/appointmentUploads/${offlineUploadRes.path}`,
                        uploadkey: offlineUploadRes.path,
                    };
                } catch (error) {
                    return reject(error);
                }
            } else {
                //upload to s3 bucket
                setLoading(true);
                try {
                    // Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_CognitoRegion });
                    // const s3UploadRes = await Storage.put(fileName, file, { contentType: file.type, customPrefix: { public: "" } });
                    // console.log("s3UploadRes", s3UploadRes);
                    // body = {
                    //     ...body,
                    //     url: `https://insta-consult.s3-ap-southeast-1.amazonaws.com/${s3UploadRes.key}`,
                    //     uploadkey: s3UploadRes.key,
                    // };
                    const formData = new FormData();
                    formData.append("file", file);
                    let params = {
                        bucket: process.env.REACT_APP_s3,
                        fileName: fileName,
                        region: process.env.REACT_APP_s3Region,
                    };

                    let s3UploadRes = await scan(formData, params);

                    if (s3UploadRes && s3UploadRes.status) {
                        s3UploadRes = s3UploadRes.data;
                        setLoading(false);
                        body = {
                            ...body,
                            url: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/${
                                s3UploadRes.key ? s3UploadRes.key : fileName
                            }`,
                            uploadkey: s3UploadRes.key,
                        };
                    } else {
                        toast.error(s3UploadRes.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }

                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                    return reject(error);
                }
            }
            return resolve(body);
        });
    };

    const uploadFile = async (e) => {
        let accepted_types = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            ".doc",
            ".docx",
            ".pdf",
            ".xls",
            ".xlsx",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ".ppt",
            ".pptx",
            "application/vnd.ms-excel",
            "image/webp",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "video/mp4",
            // "video/mp3",
            "application/zip",
            "application/x-zip-compressed",
        ];

        if (e.target.files.length > 0) {
            // for (var i = 0; i < e.target.files.length; i++) {

            // let file = e.target.files[0];

            const files = e.target.files[0];

            const fileAlreadySelected = uploaddoc?.some((file) => file?.uploadname?.toLowerCase() === files?.name?.toLowerCase());

            // let fileAlreadySelected = false;
            // for (const file of selectedFiles) {
            //     // console.log("file::::::;;;", file)
            //     if (file.name.toLowerCase() === newSelectedFile.name.toLowerCase()) {
            //         fileAlreadySelected = true;
            //         break;
            //     }
            // }

            // console.log("fileAlreadySelected:::::::::;;", fileAlreadySelected);

            if (fileAlreadySelected) {
                // setLoader(false);
                toast.dismiss();
                toast.error("File already existed");
                // toast.error("File already exists")
                return;
            }

            if (accepted_types.includes(files.type) && files.size / (1024 * 1024) < 15) {
                // console.log("file size is==== ", files.size / (1024 * 1024));

                setShowInput(true);
                setChangeFileName(files?.name);
                let filename = "appointments/" + new Date().valueOf() + files.name;
                fileNameRef.current = filename;
                fileRef.current = files;
                // try {

                //     const fileUploadResBody = await uploadOnlineOrOffline(filename, file);
                //     console.log('uploaded body------', fileUploadResBody);
                //     setHoldUploadBody(fileUploadResBody);
                //     // setUploaddoc((prevState) => [...prevState, fileUploadResBody]);
                // } catch (err) {
                //     let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
                //     console.log("upload error msg", msg);
                // }
            } else {
                //setLoading(false);
                toast.error("Please upload a valid file", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                console.log("err ==== ", "Invalid file");
            }

            // Storage.configure({ bucket: config.s3.BUCKET });

            // // console.log("filename======", filename);
            // // console.log("storage========", Storage);
            // Storage.put("appointments" + "/" + filename, file, {
            //     contentType: file.type,
            //     customPrefix: { public: "" },
            // }).then((result) => {
            //     // console.log("result=====", result);

            //     const body = {
            //         url: "https://insta-consult.s3-ap-southeast-1.amazonaws.com" + "/" + result.key,
            //         uploadkey: result.key,
            //         uploadtype: file.type,
            //         size: file.size,
            //         date: file.lastModified,
            //         uploadname: file.name,
            //         key: result.key,
            //     };
            //     // console.log("body========", body);
            //     setUploaddoc((prevState) => [...prevState, body]);

            //     //     const formData = new FormData();
            //     //     formData.append('fileData', file);
            //     //     OffLineAPI.upload("api", "/appointmentupload", formData)
            //     //         .then(res => {
            //     //             // resolve(res);
            //     //             const body = {
            //     //                 url: config.api_server + '/api/uploads/appointmentUploads/'+ res.path,
            //     //                 // url: '/uploads/appointmentUploads' + filename + res.path,
            //     //                 key: res.path,
            //     //                 uploadkey: res.path,
            //     //                 uploadtype: file.type,
            //     //                 size: file.size,
            //     //                 date: file.lastModified,
            //     //                 uploadname: file.name
            //     //             }
            //     //             setUploaddoc(prevState => [...prevState, body])

            //     //         }).catch(err => {
            //     //             console.log("error ====", err);

            //     //         });
            //     // }
            // });
        }
    };
    const deleteDocument = useCallback(
        async (data) => {
            if (data.uploadkey) {
                await deleteOnlineOrOfflineFile(data.url, data.uploadkey);
            } else {
                let _uploaddoc = uploaddoc.filter((itm) => itm.url !== data.url);
                setUploaddoc([..._uploaddoc]);
            }
        },
        [uploaddoc]
    );

    /**
     * @param {string} url - url of the file
     * @param {string} key
     */
    const deleteOnlineOrOfflineFile = async (url, key) => {
        const body = { url, key };

        try {
            if (process.env.REACT_APP_isOffline === "true") {
                const offlineDelRes = await OffLineAPI.uploadDelete("api/", "deletefile", { body });
            } else {
                // Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_profileRegion });
                // console.log("...................:)))))", Storage, url, key)
                // const s3DelRes = await Storage.remove(`${key}`);
                // console.log("s3DelRes", s3DelRes);

                let params = {
                    bucket: process.env.REACT_APP_s3,
                    fileName: fileNameRef.current,
                    region: process.env.REACT_APP_s3Region,
                };


                let s3DeleteRes = await deleteS3(params);


                if (s3DeleteRes) {
                    toast.dismiss();
                    toast.success("Delete Successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            }
            let _uploaddoc = uploaddoc.filter((itm) => itm.uploadkey !== key);
            setUploaddoc([..._uploaddoc]);
            // const deleteFilesRes = await deletefiles(body);
            // console.log("deleteFilesRes", deleteFilesRes);
            _uploaddoc = uploaddoc.filter((itm) => itm.url !== url);
            setUploaddoc([..._uploaddoc]);
        } catch (err) {
            console.log("errorin delete file =====", err);
        }
    };

    /**
     * @deprecated replaced by deleteOnlineOrOfflineFile func
     */
    // const deleteFile = (url, key) => {
    //     // console.log("3333333333333333333333333333333333");
    //     Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_s3Region });
    //     Storage.remove(key)
    //         .then((response) => {
    //             // console.log("response in delete====", response);
    //             let _uploaddoc = uploaddoc.filter((itm) => itm.key !== key);
    //             setUploaddoc([..._uploaddoc]);
    //         })
    //         .catch((err) => {
    //             console.error("err===== in delete===", err);
    //         });
    //     const body = {
    //         url: url,
    //         key: key,
    //     };

    //     // OffLineAPI.uploadDelete("api/", "deletefile", { body })
    //     //     .then(res => {
    //     //         // setLoading(false);
    //     //         let _uploaddoc = uploaddoc.filter(itm => itm.key !== key);
    //     //         setUploaddoc([..._uploaddoc]);
    //     //         // setUploaddoc(_uploaddoc);
    //     //     }).catch(err => {
    //     //         console.log("error ====", err);
    //     //         // setLoading(false);
    //     //     });

    //     // deletefiles(body)
    //     //     .then((res) => {
    //     //         console.log("res in delete files =======", res);
    //     //         let _uploaddoc = uploaddoc.filter((itm) => itm.url !== url);
    //     //         setUploaddoc([..._uploaddoc]);
    //     //     })
    //     //     .catch((err) => {
    //     //         console.log("errorin delete file =====", err);
    //     //     });
    // };

    const handleNext = () => {
        props.handleNext({ uploads: uploaddoc }, "CF");
    };

    const uploadsList = useMemo(() => {
        return uploaddoc.map((item) => {
            let extension = item.uploadtype === "youtubeUrl" ? "youtube" : item.uploadkey ? item.uploadkey.split(".").pop() : "blank";
            // console.log("extension====", extension);
            return (
                <div className="listAutoUL" key={item.uploadkey}>
                    <div className="listAutoAvtr Md listAvatarFile">
                        <img
                            src={
                                acceptedTypes?.includes(extension)
                                    ? `/images/file-icons/${extension}-file.png`
                                    : "/images/file-icons/black-file.png"
                            }
                            alt="avatar"
                        />
                    </div>
                    <div className="listAutoContent">
                        <span className="listTxtL">{item.uploadname}</span>
                        <span className="listTxtM">
                            {new Date().toLocaleString("en-US", { day: "2-digit", month: "short", year: "numeric" })}
                        </span>
                        <span className="listTxtM">{(item.size / (1024 * 1024)).toFixed(3)} MB </span>
                        <span className="listTxtM">{item.uploadtype}</span>
                    </div>
                    <div className="listAutoAction">
                        <div className="iconBtnBlock Sm ripple" onClick={(e) => deleteDocument(item)}>
                            <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                        </div>
                    </div>
                </div>
            );
        });
    }, [uploaddoc]);

    // const handleS3Delete = async (uploadkey) => {
    //     // console.log("1111111111111111111111111");
    //     Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_s3Region });
    //     const s3DelRes = await Storage.remove(uploadkey);
    //     toast.success("File removed successfully", {
    //         position: toast.POSITION.TOP_RIGHT,
    //     });
    //     console.log("s3delData------", s3DelRes);
    //     setShowInput(false);
    // };

    const handleSaveUploads = async () => {
        // setShowInput(false);
        // holdUploadBody['uploadname'] = changeFileName;
        // setHoldUploadBody((prev) => ({
        //     ...prev,
        //     uploadname : changeFileName
        // }))
        try {
            // console.log("fileNameRef===", fileNameRef);
            // console.log("fileNameRef.current===", fileNameRef.current);
            // console.log("fileRef===", fileRef);
            // console.log("fileRef.current===", fileRef.current);

            const fileUploadResBody = await uploadOnlineOrOffline(fileNameRef.current, fileRef.current);
            setShowInput(false);
            console.log("uploaded body------", fileUploadResBody);
            // setHoldUploadBody(fileUploadResBody);
            setUploaddoc((prevState) => [...prevState, fileUploadResBody]);
            toast.success("File uploaded successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
        } catch (err) {
            let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
            console.log("upload error msg", msg);
        }
    };


    return (
        <div className={props.active === "FU" ? "baColBlock secondChild secondChildSlide" : "baColBlock secondChild"}>
            {loading && <Loader />}
            {showInput && (
                <div className="flexRow listAutoUL">
                    <div className="listAutoAvtr flexAutoRow Md listAvatarFile">
                        <img
                            src={
                                acceptedTypes?.includes(fileRef.current?.name?.split(".")?.pop())
                                    ? `/images/file-icons/${fileRef.current ? fileRef.current?.name.split(".").pop() : "blank"}-file.png`
                                    : "/images/file-icons/blank-file.png"
                            }
                            alt="avatar"
                        />
                    </div>
                    <div className="flexMinWidthRow">
                        <InputField
                            placeholder="Change File Name"
                            type="text"
                            maxLength="30"
                            name="youtubeUrl"
                            value={changeFileName}
                            onChange={(e) => setChangeFileName(e.target.value)}
                        />
                    </div>
                    <div className="flexAutoRow">
                        <div className="listAutoAction" onClick={handleSaveUploads}>
                            <div className="iconBtnBlock primary Sm ripple">Save</div>
                        </div>
                        {/* <div className="listAutoAction" onClick={() => handleS3Delete(holdUploadBody?.uploadkey)}>
                            <div className="iconBtnBlock primary Sm ripple">
                                <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                            </div>
                        </div> */}
                    </div>
                </div>
            )}
            {uploaddoc && uploaddoc.length > 0 ? (
                <>
                    <div className="flexCol justifyCntr alignCntr">
                        <div className="flexRow alignCntr justifyCntr pdngTSM">
                            <div className="baUPldBtn">
                                <input
                                    type="file"
                                    title={l.chose_file}
                                    accept="image/*,.doc,.docx,.pdf,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.ppt,.pptx,video/*,.zip"
                                    onChange={uploadFile}
                                />
                                <span>{l.up_doc}</span>
                            </div>
                        </div>
                        <span className="baSTxt">{l.upload_info}</span>
                        <div className="baUploadsCol">
                            <span className="prgrsTxtL pdngHSM">{l.upl_fil_list}</span>
                            <div className="fileUploadListBlock">{uploadsList}</div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    {!showInput && (
                        <>
                            <span className="subInfoTxt txtCenter">{l.no_report_uploads}</span>
                            <NoData Heading={l.no_files} src="/images/icons/uploaded_files.png" label={l.no_file_uploads} />
                            <div className="noUploadsAction">
                                <div className="baUPldBtn">
                                    <input
                                        type="file"
                                        title={l.chose_file}
                                        accept="image/*,.doc,.docx,.pdf,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.ppt,.pptx,video/*,.zip"
                                        onChange={uploadFile}
                                    />
                                    <span>{l.up_doc}</span>
                                </div>
                                <span className="baSTxt">{l.upload_info}</span>
                            </div>
                        </>
                    )}
                </>
            )}
            {/* {showInput && (
                                <div className="flexRow listAutoUL">
                                    <div className="listAutoAvtr flexAutoRow Md listAvatarFile">
                                        <img
                                            src={
                                                fileRef.current?.name?.split(".")?.pop() === "mp4"
                                                    ? "/images/file-icons/mp4-file.png"
                                                    : `/images/file-icons/${fileRef.current ? fileRef.current?.name.split(".").pop(): 'blank'}-file.png`
                                            }
                                            alt="avatar"
                                        />
                                    </div>
                                  <div className="flexMinWidthRow">
                                  <InputField
                                        placeholder="Change File Name"
                                        type="text"
                                        name="youtubeUrl"
                                        value={changeFileName}
                                        onChange={(e) => setChangeFileName(e.target.value)}
                                    />
                                  </div>
                                   <div className="flexAutoRow">
                                   <div className="listAutoAction" onClick={handleSaveUploads}>
                                        <div className="iconBtnBlock primary Sm ripple">Save</div>
                                    </div>
                                    <div className="listAutoAction" onClick={() => handleS3Delete(holdUploadBody?.uploadkey)}>
                                        <div className="iconBtnBlock primary Sm ripple">
                                            <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                                        </div>
                                    </div>
                                   </div>
                                </div>
                            )} */}

            <div className="baFtrGtnGroup">
                <Button
                    size="md"
                    className="btn"
                    type="primary"
                    onClick={() => props.handleNext(props.formData, "VR")}
                    label={l.previous}
                />
                <Button size="md" className="btn" type="primary" onClick={handleNext} label={l.next} />
            </div>
        </div>
    );
};

export default FileUploads;

// {
//     /* <div className="prgrsCol">
//                 <span className="prgrsTxtL">{l.fil_upl}</span>
//                 <div className="prgrsBarRow">
//                     <div className="prgrsBase">
//                         <div className="prgrsBar" data-percent="75" style={{ width: "75%" }} >
//                             <span className="prgrsLabel">75%</span>
//                         </div>
//                     </div>
//                 </div>
//             </div> */
// }

// {
//     /* {uploaddoc && uploaddoc.length > 0 && <div className="baUploadsCol"> */
// }
